/* C5: Load More uses one stable, delegated click handler.
   Shopify facets can replace a section via AJAX; handlers bound to old nodes disappear. */
(() => {
  if (window.__indiehouseC5LoadMoreReady) return;
  window.__indiehouseC5LoadMoreReady = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('indie-load-more [data-ih-load-more]');
    if (!button || event.defaultPrevented || event.button !== 0 ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

    const control = button.closest('indie-load-more');
    const section = control?.closest('.shopify-section--main-collection');
    const sectionId = control?.dataset.sectionId;
    const grid = section && sectionId
      ? [...section.querySelectorAll('product-list')].find(node => node.id === 'product-list-' + sectionId)
      : null;
    if (!control || !grid || !sectionId) return;

    // Intercept before any await, even when the collection has just been AJAX-refreshed.
    event.preventDefault();
    event.stopPropagation();
    if (control.dataset.ihLoading === 'true') return;

    const requestPage = new URL(button.href, window.location.href);
    if (requestPage.origin !== window.location.origin) return;
    const endpoint = new URL(requestPage.href);
    endpoint.searchParams.set('section_id', sectionId);
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme && !endpoint.searchParams.has('preview_theme_id')) {
      endpoint.searchParams.set('preview_theme_id', previewTheme);
    }

    const label = button.querySelector('[data-ih-load-more-label]');
    const status = control.querySelector('[data-ih-load-more-status]');
    const fallback = control.querySelector('[data-ih-load-more-fallback]');
    const summary = control.closest('.ih-pagination-footer')?.querySelector('[data-ih-pagination-summary]');
    const savedX = window.scrollX;
    const savedY = window.scrollY;

    control.dataset.ihLoading = 'true';
    control.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = 'Loading…';
    if (status) status.textContent = '';
    if (fallback) fallback.hidden = true;

    try {
      const response = await fetch(endpoint.href, {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      const html = await response.text();
      const nextDoc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = [...nextDoc.querySelectorAll('product-list')]
        .find(node => node.id === grid.id);
      if (!nextGrid) throw new Error('Next page product list missing');

      const previousHandles = new Set(
        [...grid.querySelectorAll('product-card[handle]')].map(card => card.getAttribute('handle'))
      );
      const newCards = [...nextGrid.children]
        .filter(node => node.localName === 'product-card')
        .filter(node => !previousHandles.has(node.getAttribute('handle')));

      if (newCards.length === 0) throw new Error('No new products on next page');
      if (!control.isConnected || !grid.isConnected || !section.isConnected) return;

      // Products inserted after initial load must not remain hidden by reveal-on-scroll.
      for (const card of newCards) {
        card.removeAttribute('reveal-on-scroll');
        card.querySelectorAll('[reveal-on-scroll]').forEach(node => node.removeAttribute('reveal-on-scroll'));
      }

      button.blur();
      grid.append(...newCards);
      window.ihPrioritizeInStock?.(grid);

      const displayed = grid.querySelectorAll(':scope > product-card').length;
      const total = Number(control.dataset.total) || displayed;
      const start = Number(control.dataset.start) || 1;
      const last = Math.min(total, start + displayed - 1);
      if (summary) summary.textContent = 'Showing ' + start + '–' + last + ' of ' + total + ' products';

      const next = nextDoc.querySelector('indie-load-more [data-ih-load-more]');
      const nextHref = next?.getAttribute('href');
      if (nextHref) {
        button.href = new URL(nextHref, requestPage.href).href;
      } else {
        button.hidden = true;
      }

      if (status) status.textContent = button.hidden
        ? 'All ' + displayed + ' styles loaded'
        : newCards.length + ' more styles loaded';

      // Preserve the shopper's place; never jump to the top of the collection.
      window.scrollTo({ left: savedX, top: savedY, behavior: 'instant' });
      requestAnimationFrame(() => {
        if (control.isConnected) window.scrollTo(savedX, savedY);
      });
    } catch (error) {
      if (!control.isConnected) return;
      if (status) status.textContent = 'Unable to load the next styles. Please try again.';
      if (fallback) {
        fallback.href = requestPage.href;
        fallback.hidden = false;
      }
    } finally {
      delete control.dataset.ihLoading;
      if (control.isConnected) {
        control.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
        if (label) label.textContent = 'Load More';
      }
    }
  }, true);
})();
